"use client";

import { Counter } from "@/components/Motion";
import { parseStatFigure } from "@/lib/stats";

/** A stat-band figure that counts up, matching the home page hero.
 *
 *  The GCC pages store their figures as written ("110+", "11.46M"), so the
 *  number is parsed out and handed to the same <Counter> the home hero uses.
 *  A value with no number in it renders verbatim rather than animating to
 *  zero — an editor typing "Coming soon" should see "Coming soon".
 */
export function StatFigure({ value, className = "" }: { value: string; className?: string }) {
  const parsed = parseStatFigure(value);
  if (!parsed) return <span className={className}>{value}</span>;
  return (
    <Counter
      value={parsed.value}
      suffix={parsed.suffix}
      decimals={parsed.decimals}
      className={className}
      immediate
    />
  );
}
